import * as Scrivito from "scrivito";
import textWidgetIcon from "assets/images/text_widget.svg";

Scrivito.provideEditingConfig("TextMediaWidget", {
  title: "Text + Media Widget",
  thumbnail: textWidgetIcon,
  attributes: {},
  properties: ["title", "body", "media"],
  propertiesGroups: [
    {
      title: "Advanced",
      properties: [
        "complementaryText",
        "links",
        "mediaPosition",
        "mediaSize",
        "subtitle",
        "toUppercase",
      ],
    },
    {
      title: "Contact settings",
      properties: [
        "contactPerson",
        "showContactIcon",
        "contactFormLinkTxt",
        "contactIconAltTxt",
      ],
    },
  ],
  initialContent: {
    mediaPosition: "right",
    mediaSize: "small",
    toUppercase: "yes",
    showContactIcon: "no",
    contactIconAltTxt: "Symbol für Kontaktschaltfläche",
    contactFormLinkTxt: "Zum Kontaktformular",
  },
});
